import React, { useEffect, useState } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
  Card,
  CardActions,
  Button,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
  useMediaQuery,
  Grid,
} from '@material-ui/core';
import InputNumber from '../../inputNumber';
import OrderProductEdit from '../../order/orderProductEdit';
import { generateSmartComposition } from '../../../utils/productEdit';
// --- NUEVA IMPORTACIÓN ---
import { getProductPriceForDay } from '../../../utils/priceUtils';

const useStyles = makeStyles({
  root: {

    display: 'flex',

    flexDirection: 'column',

    maxWidth: 345,

    zIndex: 10,

    margin: 10,

    transition: 'transform .2s',

  },

  rootWithZoom: {

    '&:hover': {

      transform: 'scale(1.1)',

    },

  },

  rootSM: {

    maxWidth: 345,

    margin: '0 10px 20px 10px',

    transition: 'transform .2s',

  },

  rootSMWithZoom: {

    '&:hover': {

      transform: 'scale(1.05)',

    },

  },
  media: {
    minHeight: 330,
    maxHeight: 345,
  },
  price: {
    fontSize: 20
  },
  previousPrice: {
    fontSize: 18, // Ligeramente más pequeño para mejor estética
    marginRight: 8,
    textDecoration: 'line-through',
    color: '#888' // Un gris para que no llame tanto la atención
  },
  cardActions: {
    marginTop: 'auto'
  }
});

const ProductInfo = ({ sale, available }) => {
  return (
    <Grid container>
      <Grid item xs={12}>
        {sale &&
          <Typography style={{ background: '#70B67B', color: 'white', marginTop: -48 }} align='center'  >
            Oferta!
          </Typography>
        }
      </Grid>
      <Grid item xs={12}>
        {!available &&
          <Typography style={{ background: '#FF0000', color: 'white', marginTop: -24 }} align='center'  >
            Agotado
          </Typography>
        }
      </Grid>
    </Grid>
  )
}

export default function ProductCard({ product = {}, cart = {}, addToCart = () => { }, setCart = () => { }, zoomOnHover = true }) {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('sm'));
  const [editDisabled, setEditDisabled] = useState(true);
  const [editLineOpen, setEditLineOpen] = useState(false);
  const [localProduct, setLocalProduct] = useState({});

  // --- NUEVO ESTADO PARA LOS PRECIOS ---
  // Este estado guardará el resultado de nuestra lógica de precios.
  const [displayPrice, setDisplayPrice] = useState({
    finalPrice: 0,
    originalPrice: null,
    extraDiscount: null,
  });

  useEffect(() => {
    // ...tu useEffect existente (sin cambios)
    const { productsList = [] } = cart;
    const qty = getQty();
    const _product = productsList?.find(prod => prod.id === product.id) || { ...product };
    const smartComposition = _product.smartComposition || generateSmartComposition(_product).smartComposition;
    setLocalProduct({ ..._product, smartComposition, qty });

    // --- NUEVA LÓGICA DENTRO DEL useEffect ---
    // Cada vez que el producto cambie, calculamos el precio a mostrar.
    if (product.id) {
      const priceInfo = getProductPriceForDay(product);
      setDisplayPrice(priceInfo);
    }

  }, [product, cart]);


  const handleChangeQty = ({ qty = 0 }) => {
    if (qty < 1)
      qty = 0


    const item = {
      ...product,
      qty
    }

    if (typeof addToCart === 'function')
      addToCart(item)

    if (localProduct.id === item.id)
      setLocalProduct(item)
  }



  const getQty = () => {
    const prod = cart?.productsList?.find(p => p.id === product.id)
    const { qty = 0 } = prod || {}
    setEditDisabled(qty < 1)
    return qty
  }


  const handleConfirmLineEdit = (prodEdited) => {
    const { productsList } = cart
    const _productsList = productsList?.map(product => {
      if (prodEdited.id === product.id)
        return { ...prodEdited }
      return { ...product }
    })

    setCart({
      ...cart,
      productsList: _productsList
    })

  }



  const handleEditProduct = () => {

    if (localProduct.qty > 0) {

      setEditLineOpen(true)

    }

  }


  const cardClass = matches ? (zoomOnHover ? `${classes.root} ${classes.rootWithZoom}` : classes.root) : (zoomOnHover ? `${classes.rootSM} ${classes.rootSMWithZoom}` : classes.rootSM);

  return (
    <Card className={cardClass}>
      <OrderProductEdit itemToEdit={localProduct} order={cart} openForm={editLineOpen} setOpenForm={setEditLineOpen} onConfirm={handleConfirmLineEdit} />
      <CardActionArea>
        {product.src ? (
          <CardMedia className={classes.media} image={product.src} title={product.name} />
        ) : (
          product.img && <CardMedia className={classes.media} image={product.img} title={product.name} />
        )
        }
        {/* --- CAMBIO AQUÍ: La oferta se determina si hay un precio original --- */}
        <ProductInfo sale={!!displayPrice.originalPrice} available={product.stock} />

        <CardContent style={{ paddingBottom: 0 }}>
          <Typography gutterBottom variant="h5" component="h2">
            {product.name}
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p">
            {product.ingredients}
          </Typography>

          {/* --- SECCIÓN DE PRECIO COMPLETAMENTE MODIFICADA --- */}
          <Grid container alignItems="center">
            {displayPrice.originalPrice && (
              <Typography className={classes.previousPrice}>
                ${displayPrice.originalPrice}
              </Typography>
            )}
            <Typography className={classes.price} color="primary">
              ${displayPrice.finalPrice}
            </Typography>
          </Grid>
          {displayPrice.extraDiscount && (
            <Typography variant="body2" color="textSecondary">
              -${displayPrice.extraDiscount} retirando en el local
            </Typography>
          )}

        </CardContent>
      </CardActionArea>
      <CardActions disableSpacing className={classes.cardActions}>
        {/* ...resto del componente sin cambios... */}
        <Grid container>
          <Grid item xs={12} style={{ padding: 8 }}>
            <InputNumber
              label='Seleccione cantidad'
              value={localProduct.qty}
              setValue={qty => handleChangeQty({ qty })}
              width='100%'
              disabled={!product.stock}
            />
          </Grid>
          <Grid item xs={12} style={{ padding: 8 }}>
            <Button disabled={editDisabled} color="primary" variant="outlined" onClick={handleEditProduct} fullWidth>Cambiar ingredientes</Button>
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  );
}